import { CUSTOMER_TYPE, PAYMENT_METHOD, RECIPIENT_TYPES } from 'components/common/constants';

function buildTemplateRequisites(data) {
  const requisites = {};

  switch (data?.paymentMethod) {
    case PAYMENT_METHOD.SEPA:
    case PAYMENT_METHOD.SEPA_INSTANT: {
      const iban = data?.iban || data?.accountNumber;
      if (iban) requisites.iban = iban;
      break;
    }
    case PAYMENT_METHOD.FASTER_PAYMENTS:
    case PAYMENT_METHOD.BACS:
    case PAYMENT_METHOD.CHAPS: {
      if (data?.iban) {
        requisites.iban = data.iban;
      } else if (data?.accountNumber) {
        requisites.accountNumber = data.accountNumber;
        if (data?.sortCode) requisites.sortCode = data.sortCode;
      }
      break;
    }
    case PAYMENT_METHOD.SWIFT: {
      if (data?.iban) {
        requisites.iban = data.iban;
      } else if (data?.accountNumber) {
        requisites.accountNumber = data.accountNumber;
      }
      if (data?.bankCountry) requisites.bankCountry = data.bankCountry;
      if (data?.bankName) requisites.bankName = data.bankName;
      if (data?.bic) requisites.bic = data.bic;
      break;
    }
    case PAYMENT_METHOD.CRYPTO: {
      const cryptoAddress = data?.cryptoAddress || data?.accountNumber;
      if (cryptoAddress) requisites.cryptoAddress = cryptoAddress;
      const cryptoNetwork = data?.cryptoNetwork || data?.network;
      if (cryptoNetwork) requisites.cryptoNetwork = cryptoNetwork;
      break;
    }
    case PAYMENT_METHOD.INTERNAL: {
      if (data?.accountNumber) requisites.accountNumber = data.accountNumber;
      if (data?.iban) requisites.iban = data.iban;
      break;
    }
    default:
      break;
  }

  return requisites;
}

export default function CreateTemplateModel(data) {
  const requestData = {
    templateName: data?.templateName,
    amount: data?.amount,
    currency: data?.currency,
    paymentMethod: data?.paymentMethod
  };

  const requisites = buildTemplateRequisites(data);

  const beneficiary = {
    type: data?.type || CUSTOMER_TYPE[data?.recipientType?.toUpperCase()]?.toUpperCase(),
    registrationNumber: data?.registrationNumber,
    city: data?.city,
    country: data?.country,
    postCode: data?.postCode,
    state: data?.state,
    address: data?.address
  };
  if (data?.recipientType === RECIPIENT_TYPES.COMPANY && data?.companyName) beneficiary.companyName = data?.companyName;
  if (data?.recipientType === RECIPIENT_TYPES.INDIVIDUAL && data?.firstName) beneficiary.firstName = data?.firstName;
  if (data?.recipientType === RECIPIENT_TYPES.INDIVIDUAL && data?.lastName) beneficiary.lastName = data?.lastName;

  if (data?.isCryptoPayment) {
    requestData.beneficiary = {
      type: RECIPIENT_TYPES.INDIVIDUAL.toUpperCase(),
      firstName: 'Friendly',
      lastName: 'Recipient'
    };
  } else {
    requestData.comment = data?.transferDetails;
    requestData.beneficiary = beneficiary;
  }

  requestData.requisites = requisites;

  if (data?.bankCountry === 'AE' && data?.paymentPurpose) requestData.paymentPurpose = data.paymentPurpose;

  return requestData;
}
